import { ProjectModel, ProjectsState } from 'src/store/state/projects';
import { ReduxState } from 'src/store/types';
import { getProjectTargetModel } from 'src/utils/getProjectTargetModel';

// partial types
type OldProject = {
  id: string;
  publishHistory: OldPublishHistory;
  modelsById: Record<string, ProjectModel>;
  targetModelId: string;
};
type OldPublishHistory = {
  connectionInfo: {
    databaseId: string;
  };
  databaseInfo: {
    namespaceIri: string;
    namespacePrefix: string;
    shouldAddNamespace: boolean;
    shouldEnableVoicebox?: boolean;
    isPublishingSPG: boolean;
  };
};

type Project = {
  id: string;
  publishHistory: PublishHistory;
  modelsById: Record<string, ProjectModel>;
  targetModelId: string;
};
type PublishHistory = {
  connectionInfo: {
    databaseId: string;
  };
  databaseInfo: {
    namespaceInfoByModelId: Record<string, NamespaceInfo>;
    shouldEnableVoicebox?: boolean;
    isPublishingSPG: boolean;
  };
};
type NamespaceInfo = {
  iri: string;
  prefix: string;
  shouldAdd: boolean;
};

/**
 * * on {@link PublishHistory.databaseInfo} convert individual fields (`namespaceIri`, `namespacePrefix`, and `shouldAddNamespace`)
 *   to the array `namespaceInfos`
 */
// prevState must be typed as `any` since it's an older version of the Redux State
export const v38 = (prevState: any): ReduxState => {
  const nextState = { ...prevState };

  if (nextState.projects) {
    nextState.projects = v30Projects(prevState.projects);
  }

  return nextState;
};

const v30Projects = (prevProjectsState: any): ProjectsState => {
  const projectsById: Record<string, Project> = {};

  Object.entries(
    prevProjectsState.projectsById as Record<string, OldProject>
  ).forEach(([projectId, project]) => {
    const {
      namespaceIri,
      namespacePrefix,
      shouldAddNamespace,
      ...databaseInfo
    } = project.publishHistory.databaseInfo;

    projectsById[projectId] = {
      ...project,
      publishHistory: {
        ...project.publishHistory,
        databaseInfo: {
          ...databaseInfo,
          namespaceInfoByModelId:
            namespaceIri && namespacePrefix
              ? {
                  [getProjectTargetModel(project).id]: {
                    iri: namespaceIri,
                    prefix: namespacePrefix,
                    shouldAdd: shouldAddNamespace || false,
                  },
                }
              : {},
        },
      },
    };
  });

  return { ...prevProjectsState, projectsById };
};
